<h2>Exposure Vendor Quote Mapping</h2>

<app-maintenance-table [apiUrl]="url" [columnDefs]="colDefs" [keyFields]="keyColumns"></app-maintenance-table>